const useStyles = theme => ({
    // Leftside - Leaderboard
    leftContainer: {
        backgroundColor: '#BED600',
        height: '100vh',
        margin: '-1.5em',
        overflowY: 'auto',
    },
    leftTitleContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '2em',
    },
    leftTitle: {
        fontFamily: 'Maax-Bold',
        color: '#024731',
        fontSize: '2em',
        marginTop: '1em',
    },
    wmHR: {
        border: '0.5px solid #024731',
        width: '80%',
        marginTop: '0.5em',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    wmTableContainer: {
        width: '80%',
        minHeight: '65vh',
        marginLeft: 'auto',
    },
    wmTable: {
        color: '#024731',
        marginTop: '1em',
    },
    wmTableHead: {
        fontFamily: 'Maax-Bold',
        padding: '10px',
        fontSize: '1.2em',
    },
    wmTableRow: {
        fontFamily: 'Maax',
        padding: '10px',
        fontSize: '1.2em',
    },
    currentPage: {
        cursor: 'pointer',
        fontSize: '0.9em',
        paddingTop: '2px',
        color: '#024731',
    },
    otherPage: {
        cursor: 'pointer',
        fontSize: '0.9em',
        paddingTop: '2px',
        color: 'white',
    },
    // Rightside - Information
    rightContainer: {
        marginLeft: '3em',
        color: 'white',
        textAlign: 'center',
    },
    rightGrid: {
        marginTop: '1em',
    },
    largeTitle: {
        fontFamily: 'Maax-Bold',
        fontSize: '1.5em',
        marginTop: '0.5em',
        marginBottom: '0.5em',
    },
    largeText: {
        fontFamily: 'Maax-Bold',
        fontSize: '2em',
        marginTop: '0.5em',
        marginBottom: '0.5em',
    },
    extralargeText: {
        fontFamily: 'Maax-Bold',
        fontSize: '4em',
        marginTop: '0.5em',
        marginBottom: '0.5em',
    },
    noticeText: {
        fontFamily: 'Maax-Bold',
        fontSize: '6em',
        marginTop: '0.5em',
        marginBottom: '0.5em',
    },
    smallTitle: {
        fontFamily: 'Maax-Bold',
        marginTop: '0.5em',
        marginBottom: '0.5em',
    },
    wmHR2: {
        border: '0.5px solid white',
        width: '20%',
        margin: 'auto',
        textAlign: 'center',
    },
    lastgroupDiv: {
        margin: 'auto',
        border: '1px solid white',
        width: '90%',
        minHeight: '200px',
        display: 'flex',
    },
    leftDiv: {
        backgroundColor: 'white',
        width: '20%',
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    groupTitle: {
        fontFamily: 'Maax-Bold',
        color: '#024731',
        marginBottom: '1em',
        WebkitTextFillColor: 'white',
        WebkitTextStrokeWidth: '0.5px',
        WebkitTextStrokeColor: '#024731',
        fontSize: '1.6em',
    },
    groupText: {
        fontFamily: 'Maax-Bold',
        color: '#024731',
    },
    rightDiv: {
        width: '80%',
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        '& span': {
            padding: '10px',
            fontFamily: 'Maax-Bold',
            display: 'inline-block',
        },
    },
    graphLegends: {
        fontSize: '0.5em',
        fontFamily: 'Maax',
        listStyleType: 'square',
        '& li': {
            float: 'left',
        },
    },
    pageArrow: {
        color: 'white',
        fontSize: '1em',
        fontWeight: 'bold',
        cursor: 'pointer',
    },
    pageArrow2: {
        color: '#024731',
        fontSize: '1em',
        fontWeight: 'bold',
        cursor: 'pointer',
        padding: '5px',
    },
    pageArrowDisabled: {
        color: '#024731',
        fontSize: '1em',
    },
    pageArrowDisabled2: {
        color: '#BED600',
        fontSize: '1em',
    },
    chapterName: {
        fontFamily: 'Maax-Bold',
        color: '#BED600',
        padding: '10px',
    },
    chartLegend: {
        width: '10px',
        height: '10px',
        display: 'inline-block',
    },
    legendText: {
        color: 'white',
        fontFamily: 'Maax-Bold',
        fontSize: '1em',
        paddingLeft: '3px',
        paddingRight: '10px',
    },
});

export default useStyles;